import { render, staticRenderFns } from "./GetCertificateList.vue?vue&type=template&id=551b4c16&scoped=true&"
import script from "./GetCertificateList.vue?vue&type=script&lang=js&"
export * from "./GetCertificateList.vue?vue&type=script&lang=js&"
import style0 from "./GetCertificateList.vue?vue&type=style&index=0&id=551b4c16&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551b4c16",
  null
  
)

export default component.exports